module.exports = __webpack_public_path__ + "static/media/1014366.fc2af739.jpg";